module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHorizontal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": _vm.vaId
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    class: [_vm.formControl, _vm.getSize],
    attrs: {
      "type": _vm.type,
      "id": _vm.vaId,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })])]) : _c('input', {
    class: [_vm.formControl, _vm.getSize],
    attrs: {
      "type": _vm.type,
      "id": _vm.vaId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f617c44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAInput.vue
// module id = 512
// module chunks = 1